import React from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../utils/capitalize';

interface InheritedPriceDisplayProps<T> {
    directValue: T | undefined | null;
    inheritedValue?: T;
    format?: (value: T) => React.ReactNode;
}

export const InheritedPriceDisplay = <T,>({
    directValue,
    inheritedValue,
    format = (value) => value as unknown as React.ReactNode,
}: InheritedPriceDisplayProps<T>) => {
    const { t } = useTranslation();
    return (
        <>
            {directValue !== undefined && directValue !== null ? (
                <>{format(directValue)}</>
            ) : inheritedValue !== undefined && inheritedValue !== null ? (
                <span style={{ opacity: 0.5 }} title={capitalizeFirstLetter(t('inheritedFromType'))}>
                    {format(inheritedValue)}
                </span>
            ) : (
                <>-</>
            )}
        </>
    );
};
